/**
 * Legacy Pages 404 body: back link, title, message, search, optional “Trending Stories” list below (via `LatestPopularContent`).
 */
import Link from 'components/Globals/Base/Link';
import SearchBar from 'components/SearchBar';
import type { ArticlePreview } from 'interfaces/content/articles/Articles';
import { useRouter } from 'next/router';
import LatestPopularContent from '../ArticleV2/Latest';
import { BackLink, Msg, MsgLink, Title, Wrapper } from './Error404Styles';
import { NOT_FOUND_RECIRC_TRACKING } from '@/main/constants/404Recirculation';

const MAX_TRENDING_STORIES = 6;

export interface Error404Props {
  heading: string;
  link: string;
  msg: string;
  mostPopular?: ArticlePreview[];
}

export const Error404 = ({ heading, link, msg, mostPopular }: Error404Props) => {
  const router = useRouter();

  return (
    <>
      <Wrapper>
        <BackLink onClick={() => router.back()}>&#x3c; Back</BackLink>
        <Title
          as='h1'
          $fontFamily='saol'
          $size={{ default: 'level2', mdMin: 'large' }}
        >
          {heading}
        </Title>
        <Msg>
          {msg}
          <MsgLink>
            <Link href='/'>{link}</Link>
          </MsgLink>
        </Msg>
      </Wrapper>
      <SearchBar />
      {mostPopular && mostPopular.length > 0 && (
        <LatestPopularContent
          className=''
          content={{ posts: mostPopular.slice(0, MAX_TRENDING_STORIES) }}
          title='Trending Stories'
          trackingData={NOT_FOUND_RECIRC_TRACKING}
        />
      )}
    </>
  );
};

export default Error404;
